<template lang="pug">
  .social-networks-list
    .social-networks-list__item(
      v-for="link in links"
    )
      a(
        target="_blank"
        v-bind:href="link.url"
      )
        img(
          v-bind:src="link.icon"
        )
</template>

<script>
export default {
  name: "SocialNetworksList",
  props: {
    links: {
      type: Array,
      default: () => ([])
    }
  }
};
</script>
